<template>
  <div class="recycle-bin">
    <a-tabs
        :activeKey="tabKey"
        @change="handleTabChange">
      <a-tab-pane
          :key="tabOptions[0].key"
          :tab="$t(tabOptions[0].title)"
      >
        <template v-if="tabKey === tabOptions[0].key">
          <recycleHeader
              ref="recycleHeaderRef"
              :tabKey="tabKey"
              :tableList="tableList"
              @search="handleSearch"
              @refresh="refresh"
          />
          <recycleList
              ref="recycleListRef"
              :tabKey="tabKey"
              :searchKey="searchKey"
              @refreshTableList="refreshTableList"
          />
        </template>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import recycleHeader from './components/recycleHeader.vue'
import recycleList from './components/recycleList.vue'

export default {
  name: 'RecycleBin',
  components: {
    recycleHeader,
    recycleList
  },
  data() {
    return {
      tabKey: 'myRecycle',
      searchKey: '',
      tabOptions: [
        { key: 'myRecycle', title: 'project.recycleBin' },
      ],
      tableList:[]
    }
  },
  methods: {
    refreshTableList(val){
      this.tableList = val || []
    },
    handleTabChange(key) {
      this.tabKey = key
    },
    handleSearch(value) {
      this.searchKey = value
    },
    refresh(){
      this.$refs.recycleListRef.handleParamsChange()
    }
  }
}
</script>

<style lang="less" scoped>
.recycle-bin {
  width: 100%;
  height: 100%;
  color: #ffffff;
  /deep/.ant-tabs {
    color: #ffffff;
    .ant-tabs-tab {
      color: #ffffff; // 未选中的tab颜色
    }
    .ant-tabs-tab-active {
      color: #1890ff !important; // 选中的tab颜色
    }
  }
}
/deep/.ant-tabs-bar {
  border-bottom: none;
}
</style>